import CreateSearch from "./CreateSearchContainer";

export default CreateSearch;
